module.exports = __webpack_public_path__ + "static/media/import-template.9eb85f05.xlsx";